import React from 'react';
import Slider from 'react-slick';
import { HomeSlider, HomeSliderContent, HomeSliderSection } from './styles/HomeBanner.styled';
import MultilineTitle from './multilineTitle';
import Video from './video';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import ScrollDownButton from './ScrollDownButton';
import AsideMenu from './AsideMenu';
import { DWTCContext } from '../utils/context';

export default function HomeBanner({ data, id, dir }) {
  const { cssClass } = React.useContext(DWTCContext);

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 11000,
  };

  return (
    <HomeSliderSection id={id} dir={dir}>
      {cssClass.includes('events isHome') && <AsideMenu dir={dir} />}
      <Slider {...settings}>
        {data.slides.map((slide, index) => (
          <HomeSlider key={index} dir={dir}>
            <Video videoSrcURL={slide.content.videoUrl} />
            <HomeSliderContent dir={dir}>
              <MultilineTitle
                title={slide.content.title}
                description={slide.content.description || slide.content.subtitle}
                link={slide.content.link}
                dir={dir}
              />
            </HomeSliderContent>
          </HomeSlider>
        ))}
      </Slider>
      <ScrollDownButton position={data.jumpToSection} />
    </HomeSliderSection>
  );
}
